import { render } from "./PublicacaoView.vue?vue&type=template&id=15e42b3f&scoped=true"
import script from "./PublicacaoView.vue?vue&type=script&lang=js"
export * from "./PublicacaoView.vue?vue&type=script&lang=js"

import "./PublicacaoView.vue?vue&type=style&index=0&id=15e42b3f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15e42b3f"]])

export default __exports__